
export function capitalizarUpperCase(word){
    return word[0].toUpperCase() + word.slice(1, word.length);
}

export function capitalizarLowerCase(word){
    return word[0].toLowerCase(); //+ word.slice(1, word.length);
}

